import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { FeedRepostNotification } from '../shared/models/feed-repost-notification.model';

class Repost {
    notification: FeedRepostNotification;
    isOpen = false;
}

@Component({
    selector: 'feed-repost',
    templateUrl: './feed-repost.component.html',
    styleUrls: ['./feed-repost.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class FeedRepostComponent implements OnInit {

    @Input()
    set notifications(value: FeedRepostNotification[]) {
        if (value && value.length > 0) {
            this.buildReposts(value);
        }
    }

    constructor() { }

    current: FeedRepostNotification = new FeedRepostNotification();
    pastReposts: Repost[] = [];
    pastRepostOpen = false;
    hasPastReposts = false;

    debugger;

    ngOnInit() {
    }

    togglePastReposts(event: any): void {
        if (event.target.id === 'pastPosts') {
            this.pastRepostOpen = !this.pastRepostOpen;
        }
    }

    toggleRepost(respost: Repost): void {
        respost.isOpen = !respost.isOpen;
    }

    private buildReposts(posts: FeedRepostNotification[]): void {
        const sorted = this.getSorted(posts);
        this.current = sorted.splice(0, 1)[0];
        this.hasPastReposts = sorted.length > 0;
        sorted.forEach(x => {
            this.pastReposts.push(this.getRepost(x));
        });
    }



    private getSorted(reposts: FeedRepostNotification[]): FeedRepostNotification[] {
        return reposts.sort((a, b) => {
            return a.publishDate > b.publishDate ? -1 : a.publishDate < b.publishDate ? 1 : 0;
        });
    }

    private getRepost(notification: FeedRepostNotification): Repost {
        return { notification: notification, isOpen: false } as Repost;
    }

}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-repost/feed-repost.component.ts